import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import { PostOHRProvider } from "context/PostOHRContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostOHRProvider value={true}>
      <Provider store={store}>
        <Router>
          <App />
        </Router>
      </Provider>
    </PostOHRProvider>
  </React.StrictMode>
);
